// Polyfills
import 'es5-shim';
import 'es6-shim';
import Polyfills from './tools/Polyfills';
import GridTool from './tools/Grid';

// Import utils
import sptk from '../libs/sptk';
import utils from '../libs/utils';

// Modules
import ExpandsModule from './modules/ExpandsModule';
import CarouselsModule from './modules/CarouselsModule';
import AnchorsModule from './modules/AnchorsModule';
import ImplantationsModule from './modules/ImplantationsModule';
import StickiesModule from './modules/StickiesModule';
import HeaderModule from './modules/HeaderModule';
import DropdownModule from './modules/DropdownModule';
import FiltersModule from './modules/FiltersModule';
import PlayerVideoModule from './modules/PlayerVideoModule';
import ModalModule from './modules/ModalModule';
import SelectModule from './modules/SelectModule';
import CustomSelectModule from './modules/CustomSelectModule';
import LangModule from './modules/LangModule';
import RichMenuImplantations from './modules/RichMenuImplantations';
import FitImageModule from './modules/FitImageModule';
import RessourcesFilterModule from './modules/RessourcesFilterModule';
import StockModule from './modules/StockModule';
import NewsletterModule from './modules/NewsletterModule';
import GoTosModule from './modules/GoTosModule';
import LoadMoresModule from './modules/LoadMoresModule';
import CollapseListModule from "./modules/CollapseListModule";
import Slider from "./modules/Slider";
import SupHeaderModule from "./modules/SupHeaderModule";
import PopinImage from "./modules/PopinImage";
import ImgZoom from "./modules/ImgZoom";
import BannerInfo from "./modules/BannerInfo";
import FundationNavModule from "./modules/FundationNavModule";
import RSE from "./modules/RSE";
import PiliersModule from "./modules/PiliersModule";
import ScrollLinks from './modules/ScrollLinks';
import TimelineModule from './modules/TimelineModule';
import AccordionCareersModule from './modules/AccordionCareersModule';

import Counter from './classes/Counter';
import Video from './classes/VideoText';

(function (sptk, win) {
    const app = {
        initialize() {
            this.bindUI();
            this.bindEvents();

            this.sptk.initialize(this);
            utils.initialize();
        },

        bindUI() {
            this.ui = {};
            this.ui.$body = document.body;
            this.ui.$win = window;
        },

        bindEvents() {},

        sync: {
            ctx: null,

            initialize(ctx) {
                this.ctx = ctx;

                if (!sptk.utils.isMobileTablet) {
                    this.initDesktopOnlyModules();
                } else {
                    this.initMobileOnlyModules();
                }

                this.initCommonModules();
            },

            initDesktopOnlyModules() {
                // Exemple
                // this.ctx.sptk.conditionalLoad('.js-sticky', stickyNavModule.initialize.bind(stickyNavModule));
            },

            initMobileOnlyModules() {
            },

            initCommonModules() {
                this.ctx.sptk.conditionalLoad('.js-grid-toggle', () => { new GridTool() });
                // Invoke it like this
                // new ExampleModule();

                // Or like that, conditionally
            },
        },

        async: {
            ctx: null,

            initialize(ctx) {
                this.ctx = ctx;

                if (!sptk.utils.isMobileTablet) {
                    this.initDesktopOnlyModules();
                } else {
                    this.initMobileOnlyModules();
                }

                this.initCommonModules();
            },

            initDesktopOnlyModules() {
                // Exemple
                // this.ctx.sptk.conditionalLoad('.js-sticky', stickyNavModule.initialize.bind(stickyNavModule));
            },

            initMobileOnlyModules() {
            },

            initCommonModules() {
                this.ctx.sptk.conditionalLoad('.js-expand', () => { new ExpandsModule() });
                this.ctx.sptk.conditionalLoad('.js-anchors', () => { new AnchorsModule() });
                this.ctx.sptk.conditionalLoad('.js-implantations', () => { new ImplantationsModule(); })
                this.ctx.sptk.conditionalLoad('.js-sticky', () => { new StickiesModule(); })
                this.ctx.sptk.conditionalLoad('.js-nav-item', () => { new HeaderModule(); })
                this.ctx.sptk.conditionalLoad('.js-dropdown', () => { new DropdownModule(); })
                this.ctx.sptk.conditionalLoad('.js-player', () => { new PlayerVideoModule(); })
                this.ctx.sptk.conditionalLoad('.js-modal', () => { new ModalModule(); })
                this.ctx.sptk.conditionalLoad('.js-filter', () => { new FiltersModule(); })
                this.ctx.sptk.conditionalLoad('.js-image-fit', () => { new FitImageModule(); });
                this.ctx.sptk.conditionalLoad('.js-ressources-filter', () => { new RessourcesFilterModule(); });
                this.ctx.sptk.conditionalLoad('.js-custom-select', () => { new CustomSelectModule();});
                this.ctx.sptk.conditionalLoad('.js-stock', () => { new StockModule(); });
                this.ctx.sptk.conditionalLoad('.js-form-newsletter', () => { new NewsletterModule(); });
                this.ctx.sptk.conditionalLoad('.js-goto', () => { new GoTosModule() });
                this.ctx.sptk.conditionalLoad('.js-loadmore', () => { new LoadMoresModule(); });
                this.ctx.sptk.conditionalLoad('.js-popin-image-trigger', () => { new PopinImage(); });
                this.ctx.sptk.conditionalLoad('.js-fundation-nav', () => { new FundationNavModule(); });
                this.ctx.sptk.conditionalLoad('[data-scroll-to]', () => { new ScrollLinks(); });
                this.ctx.sptk.conditionalLoad('.block__accordion', () => {
                    let elements = document.querySelectorAll('.block__accordion');
                    elements.forEach(el => new PiliersModule(el));
                });
                this.ctx.sptk.conditionalLoad('.js-collapse-list', () => {
                    let elements = document.querySelectorAll('.js-collapse-list');
                    Array.prototype.forEach.call(elements, function(el, i){
                        new CollapseListModule(el);
                    });
                });
                 this.ctx.sptk.conditionalLoad('.js-counter', () => {
                    let elements = document.querySelectorAll('.js-counter');
                    Array.prototype.forEach.call(elements, function(el){
                        new Counter(el);
                    });
                });
                this.ctx.sptk.conditionalLoad('.js-video-text', () => {
                    let elements = document.querySelectorAll('.js-video-text');
                    Array.prototype.forEach.call(elements, function(el){
                        new Video(el);
                    });
                });
                this.ctx.sptk.conditionalLoad('.js-img-zoom', () => {
                    let elements = document.querySelectorAll('.js-img-zoom');
                    Array.prototype.forEach.call(elements, function(el, i){
                        new ImgZoom(el);
                    });
                });
                this.ctx.sptk.conditionalLoad('.js-sup-header', () => {
                    let elements = document.querySelectorAll('.js-sup-header');
                    Array.prototype.forEach.call(elements, function(el, i){
                        new SupHeaderModule(el);
                    });
                });
                this.ctx.sptk.conditionalLoad('.js-slider', () => {
                    let elements = document.querySelectorAll('.js-slider');
                    Array.prototype.forEach.call(elements, function(el, i){
                        new Slider(el);
                    });
                });
                this.ctx.sptk.conditionalLoad('.js-banner-info', () => {
                    let elements = document.querySelectorAll('.js-banner-info');
                    Array.prototype.forEach.call(elements, function(el){
                        new BannerInfo(el);
                    });
                });

                this.ctx.sptk.conditionalLoad('.timeline', () => {
                    let elements = document.querySelectorAll('.timeline');
                    elements.forEach(el => new TimelineModule(el));
                });

                 this.ctx.sptk.conditionalLoad('.js-accordion-careers', () => {
                    let elements = document.querySelectorAll('.js-accordion-careers');
                    elements.forEach(el => new AccordionCareersModule(el));
                });
                
                new LangModule();
                new CarouselsModule();
                new SelectModule();
                new RichMenuImplantations();
                new RSE();
                // Invoke it like this
                // new ExampleModule();

                // Or like that, conditionally
                // this.ctx.sptk.conditionalLoad('.js-example', () => { new ExampleModule() });
            },
        },

        sptk: {
            ctx: null,

            initialize(ctx) {
                this.ctx = ctx;

                this.initModules();
                this.initVariables();
                this.checkBrowsers();
            },

            initModules() {
                // sptk.utils.placeholder();
                // sptk.utils.externalLinks();
            },

            initVariables() {
                sptk.utils.$body = this.ctx.ui.$body;
                sptk.utils.$html = this.ctx.ui.$html;
                sptk.utils.$win = this.ctx.ui.$win;
            },

            checkBrowsers() {
                /*@cc_on
                    if (/^10/.test(@_jscript_version)) {
                        window.isIE10 = true;
                        window.isIE = true;

                        sptk.utils.$body.addClass('is-ie10');
                    }
                @*/

                if (navigator.userAgent.indexOf("Trident") !== -1 && navigator.userAgent.indexOf("rv:11") !== -1) {
                    window.isIE11 = true;
                    window.isIE = true;

                    sptk.utils.$body.classList.add('is-ie11');
                }

                if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) {
                    window.isSafari = true;

                    sptk.utils.$body.classList.add('is-safari');
                }
            },

            conditionalLoad(selector, callback) {
                if (document.querySelectorAll(selector).length) {
                    callback();
                }
            }
        }
    };

    // Immediate init
    app.initialize(app);

    // Once document loaded init
    document.addEventListener("DOMContentLoaded", () => {
        app.sync.initialize(app);
    });

    // Async Init (when absolutely everything is loaded like images, etc.)
    window.onload = () => {
        app.async.initialize(app);
    };

})(sptk, window);
